/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export type RxFlowConsentFlowType =
  (typeof RxFlowConsentFlowType)[keyof typeof RxFlowConsentFlowType];

export const RxFlowConsentFlowType = {
  prescription: "prescription",
  renewal: "renewal",
  undetermined: "undetermined",
} as const;
